import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

/**
 * Custom hook to dispatch setReportUsageFormObject when reportUsageFormObj changes.
 * @param {Object} params
 * @param {Object} params.reportUsageFormObj - The report usage form object.
 * @param {Function} params.dispatch - Redux dispatch function.
 * @param {Function} params.setReportUsageFormObject - Redux action creator for report usage form object.
 */
export function useReportUsageFormObject({ reportUsageFormObj, dispatch, setReportUsageFormObject }) {
    useEffectWithErrorLogging(() => {
        dispatch(setReportUsageFormObject(reportUsageFormObj));
    }, [reportUsageFormObj]);
}
